module.exports = __webpack_public_path__ + "static/media/esquina_sur_abajo_1(1).cfa8795b.jpg";